import { KycStatus } from '@/constants'
import { MutationTree } from 'vuex'
import { State } from './state'

export default <MutationTree <State>> {
  setHasActiveReleases(state, hasActiveReleases : boolean) {
    state.hasActiveReleases = hasActiveReleases
  },

  setPayoutAccounts(state, payoutAccounts : PayoutAccount[]) {
    state.payoutAccounts = payoutAccounts
  },

  setUser(state, { id, roles, username, email, countryCode } : User) {
    state.user = {
      ...state.user,
      id,
      roles,
      username,
      email,
      countryCode,
    }
  },

  setUserProfile(state, userProfile) {
    state.userProfile = userProfile
  },

  setUserStatus(state, status : UserStatus) {
    state.user.status = status
  },

  setUserKycStatus(state, status : KycStatus) {
    state.user.status.kyc = status
  },

  setUserSubscription(state, subscription : Subscription) {
    state.user.subscription = subscription
  },
  setSubscriptionError(state, hasSubscriptionError : boolean) {
    state.hasSubscriptionError = hasSubscriptionError
  },
  setUserCurrencyConversionRate(state, currencyConversionRate : number) {
    state.userCurrencyConversionRate = currencyConversionRate
  },
}
